import React from "react";

import { StyledRadio, StyledRadioLabel, StyledRadioWrapper } from "./styles";
import { RadioProps } from "./types";

/**
 * Componente Radio
 *
 * Botão de seleção exclusivo estilizado com suporte para texto associado.
 *
 * @param {string} name - Identifica o grupo de botões de rádio.
 * @param {boolean} isSelected - Indica se o botão está selecionado.
 * @param {string} label - Texto exibido ao lado do botão de rádio.
 * @param {'roundTrip' | 'oneWay'} value - Valor associado ao botão de rádio.
 * @param {(value: string) => void} onChange - Callback executado ao alterar o estado do botão.
 */
export const Radio: React.FC<RadioProps> = ({
  name,
  value,
  isSelected,
  label,
  onChange,
}) => (
  <StyledRadioWrapper>
    <StyledRadio
      type="radio"
      name={name}
      value={value}
      checked={isSelected}
      onChange={() => onChange(value)}
      aria-checked={isSelected}
    />
    <StyledRadioLabel isSelected={isSelected}>{label}</StyledRadioLabel>
  </StyledRadioWrapper>
);
